import styled from 'styled-components';

export const Icon = styled.img`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  margin: ${(props) => props.margin || '0 10px'};
  border-radius: 50%;
`;

export const Messsage = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 300px;

  label {
    color: ${(props) =>
      props.theme.title === 'light'
        ? props.theme.colors.black
        : props.theme.colors.label};
    font-weight: bold;
  }
`;

export const Button = styled.div`
  display: flex;
  width: 116px;
  height: 26px;
  color: ${(props) => props.theme.colors.lightblue};
  text-transform: uppercase;
  border-radius: 10px;
  border: ${(props) =>
    props.heat >= 80
      ? `1px solid ${props.theme.colors.red}`
      : `1px solid ${props.theme.colors.lightblue}`};
  font-weight: bold;
  font-size: 11px;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.heat >= 80 ? props.theme.colors.red : props.theme.colors.white};
  cursor: pointer;
  transition: background-color 0.3s;

  :hover {
    background: ${(props) => props.theme.colors.lightblue};
    color: ${(props) =>
      props.heat >= 80 ? props.theme.colors.red : props.theme.colors.white};
  }
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;

  :hover:not(:disabled) {
    background: ${(props) => props.theme.colors.disabled};
    border-color: ${(props) => props.theme.colors.lightblue};
    transform: scale(1.05);
  }

  :disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }

  :focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.lightblue};
    outline-offset: 2px;
  }
`;

// Container das acoes da linha (Marcar como visualizado + Ver maquina).
// gap mantem espacamento consistente; centralizado em coluna estreita.
export const RowActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

// Pill de status: "Pendente" (vermelho) ou "Visualizado" (verde). Mais
// intuitivo que checkbox + texto — operador entende o estado de relance.
export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  background: ${(props) =>
    props.visualized
      ? props.theme.colors.green
      : props.theme.colors.red};
  color: ${(props) => props.theme.colors.white};
`;

export const StatusDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.white};
`;

// Dot de severidade no inicio da linha (cor por tipo de alarme).
// Permite triagem visual rapida sem precisar ler o "Tipo de alarme".
export const SeverityDot = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) => props.color};
  flex-shrink: 0;
  margin-right: 8px;
`;

export const CheckboxInput = styled.input`
  width: 18px;
  height: 18px;
  margin: 0;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  accent-color: ${({ theme }) => theme.colors.blue};
`;

export const Temperature = styled.label`
  color: ${(props) => props.color};
  font-size: 14px;
`;

export const ButtonLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 0 0 17px;

  #red {
    width: 50px;
    height: 16px;
    background: ${(props) => props.theme.colors.red};
    margin: 0 15px 0 0;
    border-radius: 10px;
  }

  #orange {
    width: 50px;
    height: 16px;
    background: ${(props) => props.theme.colors.orange};
    border-radius: 10px;
  }
`;

export const UserContainer = styled.div`
  display: flex;
  width: 65px;
  height: 32px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
  background: ${(props) =>
    props.theme.title === 'light'
      ? props.status === 'resolvido'
        ? props.theme.colors.green
        : props.status === 'resolvendo'
        ? props.theme.colors.disabled
        : props.theme.colors.white
      : props.status === 'resolvido'
      ? props.theme.colors.green
      : props.status === 'resolvendo'
      ? props.theme.colors.disabled
      : 'transparent'};
`;

export const Label = styled.label`
  font-size: 15px;
  font-weight: 600;
  color: ${(props) => (props.color ? props.color : props.theme.colors.label)};
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-right: 20px;
`;

export const floaterStyles = {
  wrapper: {
    cursor: 'normal',
  },
  container: {
    padding: "5px 15px",
    borderRadius: 4,
    fontSize: 12,
    minHeight: 'unset',
    minWidth: 'unset',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: "0.2s"
  },
  arrow: {
    display: 'none',
  }
}
